// extracted by mini-css-extract-plugin
export default {"pageLayout":"ExternalJobBoardsStats-module__pageLayout___LnTqZ"};